import React from 'react';
import EcxSurveyEditor  from "../helpers/ecxsurvey/EcxSurveyEditor";
import { useSurveyStore } from "../helpers/ecxsurvey/surveyutilities/surveyStore";
import surveyService from "../../services/survey.service";
import { toast } from 'react-toastify';

const SurveyCreate = () => {
    const exportToJSON = useSurveyStore(state => state.exportToJSON);

    const handleSave = async () => {
        try {
            const surveyData = exportToJSON();
            
            // Remove id from survey for create request
            const { id, ...surveyWithoutId } = surveyData.survey;
            
            // Add templateType to survey (icon and iconColor are in editor defaults)
            const surveyWithAdditionalFields = {
                ...surveyWithoutId,
                templateType: surveyWithoutId.templateType || 'template'
            };
            
            const requestData = {
                ...surveyData,
                survey: surveyWithAdditionalFields
            };
            
            const response = await surveyService.saveEcxSurveyTemplate(requestData);
            console.log('Survey template saved successfully:', response.data);
            toast.success('Survey template saved successfully!');
        } catch (error) {
            console.error('Error saving survey template:', error);
            toast.error('Failed to save survey template. Please try again.');
        }
    }

    return (
        <div>
            <EcxSurveyEditor onSave={handleSave}/>
        </div>
    );
};

export default SurveyCreate;